import { useEffect, useState } from "react";
import { setBackHandler, setHeaderTitle } from "../../../helpers/header.helper";
import { buttonLabels, pageTitles } from "../../shared/constants";
import ButtonComponent from "../../shared/button/button.component";
import { BirdLogo, InfoCircleIcon, IntegrationIcon, NewInfoCircleIcon, TeamsIntRectIcon } from "../../../icon";
import { UserService } from "../../../services/UserService";
import { useLocation, useNavigate } from "react-router";
import { IntegrationSetupService } from "../../../services/IntegrationSetup";
import { AppRoutes, WebRoutes } from "../../routes/route.path";
import Config from "../../../config";
import { ToasterType } from "../../shared/toaster/toaster.model";
import setToast from "../../../helpers/toaster.helper";

type Props = {}

interface ConsentModal {
    orgId: string;
    name: string;
    integrationCode: string;
    integrationStatus: boolean;
}

function MSActivityFeedSetup({ }: Props) {

    const location = useLocation();
    const navigate = useNavigate()

    const [permission, setPermission] = useState<boolean>(false)
    const [loading, setLoading] = useState<boolean>(false);

    useEffect(() => {
        setHeaderTitle(pageTitles.MS_TEAMS_ACTIVITY_FEED_SETUP);
        setBackHandler(() => navigate(AppRoutes.INTEGRATIIONS))
    }, [])

    useEffect(() => {
        setLoading(true);
        const params = new URLSearchParams(location.search);
        if (params.get('connection') === 'true') {
            setPermission(true);
            setLoading(false);
        }
        else if (params.get('admin_consent') === 'True') {
            // setPermission(true);
            setLoading(false);
            setAdminConsent({
                orgId: UserService.getCurrentUserOrgId(),
                name: "Teams Activity Feed Notification",
                integrationCode: IntegrationSetupService.TeamsActivityFeed_Code,
                integrationStatus: params.get('admin_consent') === 'True'
            })
        }
        else {
            setPermission(false);
            setLoading(false);
        }
    }, [location.search])

    const setAdminConsent = (data: ConsentModal) => {
        IntegrationSetupService.updateIntegrationStatus(data)
            .then((res) => {
                setPermission(!permission);
                setToast("Updated sucessfully", ToasterType.SUCCESS);
            })
            .catch((err) => {
                setPermission(false);
            })
    }

    const handleAdminConsent = () => {
        const clientId = Config.SSO_LOGIN_AZURE_AD_CLIENT_ID;
        const scope = 'https://graph.microsoft.com/TeamsActivity.Send';
        const redirectUri = `${Config.APP_FE_URL}${WebRoutes.TEAMS_ACTIVITY_FEED}`;
        const responseType = 'code';

        const permissionUrl = `https://login.microsoftonline.com/common/adminconsent?client_id=${clientId}&scope=${scope}&redirect_uri=${redirectUri}&response_type=${responseType}`;

        // Redirect to the admin consent URL
        window.location.href = permissionUrl;
    };

    return (
        <div className='d-flex w-p-100 h-p-100 bg-color-profile-primary-background'>
            <div className="d-flex flex-direction w-fill h-fill m-1 bg-color-secondary br-5 bg-color-integrate-ms-teams-header">
                <div className="d-flex w-fill  brt-5 h-15 mx-3">
                    <div className='d-flex align-center'>
                        <span ><TeamsIntRectIcon /></span>
                        <span className="h1-semibold my-auto ml-1">Microsoft Teams</span>
                        <span className="my-auto mx-2"><IntegrationIcon /></span>
                        <span className="my-auto mx-2"><BirdLogo /></span>
                    </div>
                    <div className="d-flex my-auto ml-auto">
                        <ButtonComponent Variant={permission ? "secondary-btn" : "primary-btn"}
                            OnClick={permission ? () => setAdminConsent({
                                orgId: UserService.getCurrentUserOrgId(),
                                name: "Teams Activity Feed Notification",
                                integrationCode: IntegrationSetupService.TeamsActivityFeed_Code,
                                integrationStatus: false
                            }) : handleAdminConsent}
                            Type="button"
                            ButtonLabel={loading ? "" : permission ? buttonLabels.DISCONNECT : buttonLabels.REQUEST_CONSENT}
                            Loading={loading}
                        />
                    </div>
                </div>
                <div className="d-flex bg-color-secondary justify-around w-p-100 my-2 flex-wrap h-v-60 o-y-scroll">
                    {/* <IntegrateChannels organizationId={UserService.getCurrentUserOrgId()} isAdminConcentSucess={permission} /> */}
                </div>
            </div>
        </div>)
}

export default MSActivityFeedSetup